import ROUTES from '../../../constants/routes';

export const AI_TOOLS_NOTIFICATIONS = 'ai_tools';

export const GENERATION_PANEL_MODE = {
    CREATE: 'create',
    VIEW: 'view',
    EDIT: 'edit'
};

export enum DROPDOWN_OPTIONS {
    DIFFICULTY = 'difficulty',
    LENGTH = 'length',
    ANSWER_LENGTH = 'answerLength'
}

export const AI_TABS_ITEMS = [
    {
        title: 'tools',
        path: ROUTES.AI_TOOLS.path,
        childrenRoutes: [ROUTES.AI_TOOL_PAGE.path, ROUTES.AI_TOOL_DOCUMENT.path]
    },
    {
        title: 'documents',
        path: ROUTES.AI_TOOLS_DOCUMENTS.path
    },
    {
        title: 'faq',
        path: ROUTES.AI_TOOLS_FAQ.path
    }
];
export const AI_TOOLS_FAQ_LIST = [
    {
        id: 1,
        title: 'aiTools.faqPage.faqList.faq_1.question',
        content: 'aiTools.faqPage.faqList.faq_1.answer'
    },
    {
        id: 2,
        title: 'aiTools.faqPage.faqList.faq_2.question',
        content: 'aiTools.faqPage.faqList.faq_2.answer'
    },
    {
        id: 3,
        title: 'aiTools.faqPage.faqList.faq_3.question',
        content: 'aiTools.faqPage.faqList.faq_3.answer'
    },
    {
        id: 4,
        title: 'aiTools.faqPage.faqList.faq_4.question',
        content: 'aiTools.faqPage.faqList.faq_4.answer'
    },
    {
        id: 5,
        title: 'aiTools.faqPage.faqList.faq_5.question',
        content: 'aiTools.faqPage.faqList.faq_5.answer'
    },
    {
        id: 6,
        title: 'aiTools.faqPage.faqList.faq_6.question',
        content: 'aiTools.faqPage.faqList.faq_6.answer'
    },
    {
        id: 7,
        title: 'aiTools.faqPage.faqList.faq_7.question',
        content: 'aiTools.faqPage.faqList.faq_7.answer'
    }
];
